import {
  makeAutoObservable,
  reaction,
  runInAction,
  observable,
  observe,
  autorun,
} from "mobx";
import { commonAxios } from "../../CommonAxios";
import { showAlertToast } from "../../../../Components/ToastComponent/AlertMessage";
import { json } from "react-router-dom";
class ExportStore {
  showModal = false;
  selectedFields = new Map();
  enrichedFields = new Map();
  noOfContacts = 1;
  exportName = "";
  noOfContactspercompanies = 0;
  exportType = "csv";
  isCrmSelected = false;
  enrichedSelectedFields = []
  utilizingCredits = 0;
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }
  setShowModal = (value) => {
    this.showModal = value;
  };

  setCrmSelected(value) {
    this.isCrmSelected = value;
  }
  setNoOfContcts = (value) => {
    if (value < 0) {
      showAlertToast({
        type: "warning",
        title: "No of Contacts",
        message: "Please enter a valid number",
      });
      return;
    }
    this.noOfContacts = value;
  };
  setExportName = (value) => {
    if (value === "") {
      showAlertToast({
        type: "warning",
        title: "Export Name",
        message: "Please enter a Export Name",
      });
      return;
    }
    this.exportName = value;
  };
  setNoOfContctsperContact = (value) => {
    if (value < 0) {
      showAlertToast({
        type: "warning",
        title: "No of Contacts",
        message: "Please enter a valid number",
      });
      return;
    }
    this.noOfContactspercompanies = value;
  };
  setExportType = (value) => {
    this.exportType = value;
  };
  setUtilizingCredits = (value) => {
    this.utilizingCredits = value;
  };
  toggleFieldSelection = (fieldOrGroup, e) => {
    const temp = this.utilizingCredits;
    runInAction(() => {
      const isGroup = Array.isArray(fieldOrGroup.fields);
      const groupKey = isGroup ? fieldOrGroup.value : fieldOrGroup.groupValue;
      const fieldValue = fieldOrGroup.value;
      let groupFields = this.selectedFields.get(groupKey) || new Set();
      if (isGroup) {
        const fullGroup = this.rootStore.fieldMapperStore.fieldGroups.find(g => g.value === groupKey);
        const allFieldValues = fullGroup.fields.map(f => f.value);
        const isFullySelected =
          this.selectedFields.has(groupKey) &&
          groupFields.size === fullGroup.fields.length;
        if (isFullySelected) {
          this.selectedFields.delete(groupKey);
          this.setUtilizingCredits(temp - fieldOrGroup.price);
        } else {
          this.selectedFields.set(groupKey, new Set(allFieldValues));
          if (!this.selectedFields.has(groupKey) || groupFields.size === 0) {
            this.setUtilizingCredits(temp + fieldOrGroup.price);
          }
        }
      } else {
        // Toggle individual field
        if (groupFields.has(fieldValue)) {
          groupFields.delete(fieldValue);
        } else {
          groupFields.add(fieldValue);
        }
        if (groupFields.size > 0) {
          this.selectedFields.set(groupKey, groupFields);
        } else {
          this.selectedFields.delete(groupKey);
        }
        const fullGroup = this.rootStore.fieldMapperStore.fieldGroups.find(g => g.value === groupKey);
        const isFullySelected =
          fullGroup && groupFields.size === fullGroup.fields.length;
        // Automatically convert to full group selection if all are selected
        if (isFullySelected) {
          this.selectedFields.set(groupKey, new Set(fullGroup.fields.map(f => f.value)));
        }
        if (groupFields.size === 1) {
          this.setUtilizingCredits(temp + fieldOrGroup.price);
        }
        if (groupFields.size === 0) {
          this.setUtilizingCredits(temp - fieldOrGroup.price);
        }
      }
    });
  };
  isFieldSelected = (groupKey, fieldValue) => {
    return (
      this.selectedFields.has(groupKey) &&
      this.selectedFields.get(groupKey).has(fieldValue)
    );
  };
  isGroupSelected = (group) => {
    const selected = this.selectedFields.get(group.value);
    return selected?.size === group.fields.length;
  };
  getTableBundleNames = async () => {
    try {
      const response = await commonAxios(
        `/getTableBundleNames`,
        "GET",
        {
          tableId: this.rootStore.gridStore.tabIndex === 0
            ? this.rootStore.gridStore.tableCompanyId
            : this.rootStore.gridStore.tablePeopleId
        },
        {}
      );
      const newSelectedFields = new Map();
      Object.entries(response?.data?.fieldsInfo ?? {}).forEach(([key, valueArray]) => {
        newSelectedFields.set(key, new Set(valueArray));
      });
      this.enrichedSelectedFields = response?.data?.bundleName || [];
      const totalGroupPrice = Array.from(newSelectedFields.keys()).reduce((acc, groupKey) => {
        const group = this.rootStore.fieldMapperStore.fieldGroups.find(g => g.value === groupKey);
        const groupPrice = group?.price || 0;
        return acc + groupPrice;
      }, 0);
      const creditsUtilized = totalGroupPrice * this.noOfContacts;
      runInAction(() => {
        this.selectedFields = newSelectedFields;
        this.enrichedFields = newSelectedFields;
        this.utilizingCredits = creditsUtilized;
        this.showModal = true
      });
    } catch (e) {
    }
  };
  exportData = async (navigate) => {
    try {
      const selectedvalueString =
        this.selectedFields.size > 0
          ? Array.from(this.selectedFields.keys()).join(",")
          : "";
      const customFieldsString = Array.from(this.selectedFields.values())
        .flatMap(set => Array.from(set))
        .join(',');
      const keyValueObject = Object.fromEntries(
        Array.from(this.selectedFields.entries()).map(([key, valueSet]) => [
          key,
          Array.from(valueSet),
        ])
      );
      const res = await commonAxios(
        "/enrich/export",
        "POST",
        {},
        {
          tableId:
            this.rootStore.gridStore.tabIndex === 0
              ? this.rootStore.gridStore.tableCompanyId
              : this.rootStore.gridStore.tablePeopleId,
          type: this.rootStore.gridStore.tabIndex === 0 ? "company" : "people",
          exportName: this.exportName,
          count: this.noOfContacts,
          // noOfContactspercompanies: this.noOfContactspercompanies,
          fields: selectedvalueString,
          customFields: customFieldsString,
          fieldsInfo: keyValueObject,
          savedSearchData: this.rootStore.savedSearchPayload,
          // crmStatus: this.rootStore.gridStore.isEnablePustCrm? true : false,
          crmStatus: this.exportType === "csv",
        }
      );
      if (res) {
        showAlertToast({
          type: "success",
          title: "Success",
          message: res.message,
        });
        runInAction(() => {
          this.anchorE2Tab = null;
          this.setShowModal(false);
          if (this.rootStore.gridStore.tabIndex === 1) {
            localStorage.setItem("searchPeopleInfo", JSON.stringify(false));
          }
          if (this.rootStore.gridStore.tabIndex === 0) {
            localStorage.setItem("searchCompanyInfo", JSON.stringify(false));
          }
          this.rootStore.clearAll();
        });
        setTimeout(() => {
          navigate("/saved-table");
        }, 2000);
      }
      // downloadFileFromURL(res?.data?.url);
      return false;
    } catch (error) {
      showAlertToast({
        type: "error",
        title: "Error",
        message: error?.response?.data?.error?.message,
      });
    }
  };
  enrichementApiCall = async (userId, tableId, apiUrl) => {
    try {
      runInAction(() => {
        this.rootStore.callCommonLoader(true);
      });
      const response = await commonAxios(
        apiUrl,
        "POST",
        {},
        {
          tableId: tableId,
          userId: userId,
          fields: Array.from(this.selectedFields)
            .map((item) => item.value)
            .join(","),
          rowIds: "all",
          startRange: this.rowLimitRanges.fromRange,
          endRange: this.rowLimitRanges.toRange,
        }
      );
      if (response) {
        runInAction(() => {
          this.rootStore.applyTheValue({ showModalEnrichment: false });
          this.rootStore.callCommonLoader(false);
          localStorage.setItem("searchCompanyInfo", JSON.stringify(true));
        });
      }
    } catch (error) {
      runInAction(() => {
        this.rootStore.callCommonLoader(false);
      });
      showAlertToast({
        type: "warning",
        title: `Note`,
        message: error?.response?.data?.error?.message,
      });
    }
  };
  clearSelectedValue = () => {
    runInAction(() => {
      this.selectedFields.clear();
      this.enrichedFields.clear();
    });
  };
}
export default ExportStore;
